<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="FAQ e-service" />
            <FaqServiceComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FaqServiceComp from '../Faq/FaqServiceComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'FaqEservicePage',
    components: {
        NavBar,
        PageTitle,
        FaqServiceComp,
        FooterComp,
    }
}
</script>